import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import styles from './ScheduledStudentsPopup.module.scss';
import ProfilePicture from '../../../../components/profilePicture/ProfilePicture';
import Icon from '../../../../components/icon/Icon';

const ScheduledStudentsPopup = ({ 
  title, 
  subtitle, 
  students = [], 
  position, 
  onClose 
}) => {
  const popupRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popupRef.current && 
        !popupRef.current.contains(event.target) &&
        !event.target.closest('.allocated-cell') 
      ) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  if (!position) return null;

  const filteredStudents = students.filter(student => 
    `${student.firstName} ${student.lastName}`.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return createPortal(
    <div 
      className={styles.popup}
      style={{
        position: 'absolute',
        top: `${position.top}px`,
        left: `${position.left}px`,
        transform: position.isNearBottom ? 'translateY(-100%)' : 'none'
      }}
      ref={popupRef}
    >
      <button className={styles.closeBtn} onClick={onClose}>
        <Icon name="plus" className={styles.crossIcon} />
      </button>

      <div className={styles.header}>
        <h3 className={styles.title} title={title}>{title}</h3>
        <p className={styles.subtitle}>{subtitle}</p>
      </div>

      <div className={styles.searchContainer}>
        <input 
          type="text" 
          placeholder="Search Students" 
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className={styles.searchInput}
        />
      </div>

      <div className={styles.studentList}>
        {filteredStudents.length > 0 ? (
          filteredStudents.map((student) => (
            <div key={student.id} className={styles.studentItem}>
              <ProfilePicture 
                src={student.profilePicture} 
                firstName={student.firstName} 
                lastName={student.lastName} 
                size="xsm"
              />
              <span 
                className={styles.studentName}
                title={`${student.firstName} ${student.lastName}`}
              >
                {`${student.firstName} ${student.lastName}`}
              </span>
            </div>
          ))
        ) : (
          <div className={styles.noResults}>No students found</div>
        )}
      </div>
    </div>,
    document.body
  );
};

ScheduledStudentsPopup.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  students: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    profilePicture: PropTypes.string
  })),
  position: PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number,
    isNearBottom: PropTypes.bool
  }),
  onClose: PropTypes.func
};

export default ScheduledStudentsPopup;
